import React, { useCallback } from 'react';
import adminApi from '../../services/adminApi';
import StayInventoryDashboard from '../../components/inventory/StayInventoryDashboard';
import { AdminPageHeader } from '../../components/admin/AdminShared';

const AdminInventory = () => {
  const fetchStays = useCallback(() => adminApi.getStays(), []);

  return (
    <>
      <AdminPageHeader
        title="Inventory"
        subtitle="30-day availability by room — pick a stay to view and edit"
      />
      <StayInventoryDashboard fetchStays={fetchStays} theme="admin" />
    </>
  );
};

export default AdminInventory;
